import React from 'react';
import { Popper } from 'react-popper';

interface Props {
  open: boolean;
}

class TabsPopover extends React.Component<Props> {
  render(): React.ReactNode {
    const { open, children } = this.props;

    return (
      <Popper placement="bottom-start">
        {({ ref, placement }): React.ReactNode => {
          return open ? (
            <div
              ref={ref}
              className="bgd-white-2 b-3 font-size-4 black-2 oh"
              style={{
                width: '100%',
                position: 'absolute',
                top: '90px',
                zIndex: 10,
              }}
              data-placement={placement}
            >
              {children}
            </div>
          ) : null;
        }}
      </Popper>
    );
  }
}

export default TabsPopover;
